/* eslint-disable no-console */
import requester from '../utils/requester';
import config from '../config';

import syncOfflineEvents from './syncHandlers/syncOfflineEvents';
import syncOfflineEditAnimals from './syncHandlers/syncOfflineEditAnimals';
import syncOfflineAnimals from './syncHandlers/syncOfflineAnimals';
import syncOfflineEventMessages from './syncHandlers/syncOfflineEventMessages';

// for sending local submitted items to the server.
// since it's more important to sync, I'm setting this to check every 5 min
const syncPendingRecordsOnOfflineDB = async () => {
    const result = await requester.authNeed().contentType('application/json').get(config.serverURL + '/token/check');
    if (result?.data?.results?.[0]?.token) {
        const offlineDBPendingLastUpdate = localStorage.getItem('offlineDBPendingLastUpdate');
        const fiveMin = 5 * 60 * 1000; // ms
        if (!offlineDBPendingLastUpdate || (((new Date()) - (new Date(offlineDBPendingLastUpdate))) > fiveMin)) {
            try {
                localStorage.setItem('offlineDBPendingLastUpdate', new Date());
                sendPendingItemsInOfflineDB();
            }
            catch (err) {
                console.log(err);
            }
        }
    }
    else {
        localStorage.removeItem('offlineDBPendingLastUpdate');
    }
}

// local -> server
const sendPendingItemsInOfflineDB = () => {
    syncOfflineEvents();
    syncOfflineEditAnimals();
    syncOfflineAnimals();
    syncOfflineEventMessages();
}

export default syncPendingRecordsOnOfflineDB;
